module.exports = __webpack_public_path__ + "static/media/waterfall-banff.8b18e388.jpg";